import useGetCustomerRepresentatives from './useGetCustomerRepresentatives'

export default useGetCustomerRepresentatives
